import { Action, Dispatch } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'slices';
import { profileFailed, profileSuccess } from './reducer';

interface User {
  username: string;
  idx: number;
}

export const editProfile =
  (user: User): ThunkAction<void, RootState, unknown, Action<string>> =>
  async (dispatch: Dispatch) => {
    try {
      let response: any;
      if (response) {
        dispatch(profileSuccess(response));
      }
    } catch (error) {
      dispatch(profileFailed(error));
    }
  };
